import * as React from "react";

import {
  Box,
  Container,
  Divider,
  Grid,
  makeStyles,
  Theme,
} from "@material-ui/core";

import { Header } from "client/components";
import { LeadForm } from "client/domain";

import { headerHeight } from "../utils";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "initial",
    },
  },
  container: {
    height: `calc(100% - ${headerHeight}px)`,
    [theme.breakpoints.down("sm")]: {
      // put non-form content below the form on mobile
      display: "flex",
      flexDirection: "column-reverse",
    },
  },
  form: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
}));

type Props = {
  leftColumn?: React.ReactNode;
  rightColumn?: React.ReactNode;
};

export const BaseLayout: React.FC<Props> = ({
  leftColumn,
  rightColumn = <LeadForm />,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Container fixed>
        <Header />
      </Container>
      <Divider />
      <Grid
        className={classes.container}
        container
        justifyContent={leftColumn ? "flex-start" : "center"}
      >
        {leftColumn && (
          <>
            <Grid item sm={12} md={5}>
              {leftColumn}
            </Grid>
            <Grid md={1} item />
          </>
        )}
        <Grid item sm={12} md={4}>
          <Box className={classes.form}>{rightColumn}</Box>
        </Grid>
      </Grid>
    </Box>
  );
};
